/* GGG 2.0: scroll reveal for .rv and knob/seal rotation, from the GGG2.0 demo */
(function () {
  var root = document.documentElement;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('ggg-js');
  // circuit board background layer and its stylesheet (sits next to this file in assets)
  var me = document.currentScript;
  if (me && !document.querySelector('.ggg-circuit')) {
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = me.src.replace('/ggg.js', '/ggg-circuit.css');
    document.head.appendChild(css);
    var bg = document.createElement('div');
    bg.className = 'ggg-circuit';
    bg.setAttribute('aria-hidden', 'true');
    bg.innerHTML = '<i class="ggg-circuit__a"></i><i class="ggg-circuit__b"></i>';
    document.body.insertBefore(bg, document.body.firstChild);
  }
  var els = [].slice.call(document.querySelectorAll('.rv'));
  function show(e) { e.classList.add('in'); }
  if (rm || !('IntersectionObserver' in window)) { els.forEach(show); return; }
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (e) { io.observe(e); });
  var tick = false;
  function sc() {
    tick = false;
    var y = window.pageYOffset;
    root.style.setProperty('--rot', (y * 0.22).toFixed(1));
    // circuit background parallax: the fine traces drift slowly, the big parts a little faster
    root.style.setProperty('--cya', (y * -0.12).toFixed(1));
    root.style.setProperty('--cyb', (y * -0.3).toFixed(1));
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(sc); } }, { passive: true });
})();
